import styled from 'styled-components';

export const Content = styled.div`
  display: grid;
  margin: 24px auto;
`;

export const Title = styled.h1`
  margin-top: 0;
  margin-bottom: 24px;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.25;
  color: #1b1b1b;
`;
